import DatePicker from "components/inputs/DatePicker/DatePicker";
import TextInput from "components/inputs/TextInput/TextInput";
import { DATE_TO_STRING, STRING_TO_DATE } from "utils/date-utils";
import type { EditableCodeDateDetail } from "../../utils/codeMetadataUtils";

type CodeReferenceListProps = {
  codeId: number;
  dateDetails: EditableCodeDateDetail[];
  documentGroupId: number | null;
  provider: string;
  facility: string;
  onDateChange: (detailId: string, value: string) => void;
  onDateSave: (detailId: string, value: string) => Promise<void>;
  onProviderChange: (value: string) => void;
  onProviderSave: (value: string) => Promise<void>;
  onFacilityChange: (value: string) => void;
  onFacilitySave: (value: string) => Promise<void>;
  getReferenceContext: (args: {
    pageNumber: string;
    documentGroupId?: number | null;
    facility?: string | null;
    provider?: string | null;
  }) => {
    resolvedDocumentGroupId: number | null;
    resolvedFacility: string;
    provider: string;
  };
};

/*
displays date details with document group and facility labels
used within code cards to show reference information
*/
const CodeReferenceList = ({
  codeId,
  dateDetails,
  documentGroupId,
  provider,
  facility,
  onDateChange,
  onDateSave,
  onProviderChange,
  onProviderSave,
  onFacilityChange,
  onFacilitySave,
  getReferenceContext,
}: CodeReferenceListProps) => (
  <div className="metadoc-viewer-workspace__code-reference-list">
    <div className="metadoc-viewer-workspace__code-reference-label-row">
      <span className="metadoc-viewer-workspace__code-field-label metadoc-viewer-workspace__code-reference-label metadoc-viewer-workspace__code-reference-label--date">
        Date
      </span>
      <span className="metadoc-viewer-workspace__code-field-label metadoc-viewer-workspace__code-reference-label metadoc-viewer-workspace__code-reference-label--facility">
        Facility
      </span>
      <span className="metadoc-viewer-workspace__code-field-label metadoc-viewer-workspace__code-reference-label metadoc-viewer-workspace__code-reference-label--group">
        Provider
      </span>
    </div>
    {dateDetails.map((dateDetail) => {
      const { provider: resolvedProvider, resolvedFacility } =
        getReferenceContext({
          pageNumber: dateDetail.pageNumber,
          documentGroupId,
          provider,
        });

      const effectiveFacility = facility || resolvedFacility;

      return (
        <div
          key={dateDetail.id}
          className="metadoc-viewer-workspace__code-reference-row"
        >
          <DatePicker
            className="metadoc-viewer-workspace__code-reference-editor--date"
            name={`code-${codeId}-reference-date-${dateDetail.id}`}
            initialDate={STRING_TO_DATE(dateDetail.date)}
            isClearable={false}
            onDateChange={(date) => {
              onDateChange(
                dateDetail.id,
                DATE_TO_STRING(date, "MM/dd/yyyy") ?? "",
              );
            }}
            onBlur={() => {
              void onDateSave(dateDetail.id, dateDetail.date);
            }}
          />
          <TextInput
            classNames="metadoc-viewer-workspace__code-reference-editor metadoc-viewer-workspace__code-reference-editor--facility"
            name={`code-${codeId}-reference-facility-${dateDetail.id}`}
            value={effectiveFacility}
            placeholder="No facility."
            onChange={(event) => {
              onFacilityChange(event.target.value);
            }}
            onBlur={async (event) => {
              await onFacilitySave(event.target.value);
            }}
          />
          <TextInput
            classNames="metadoc-viewer-workspace__code-reference-editor metadoc-viewer-workspace__code-reference-editor--group"
            name={`code-${codeId}-reference-provider-${dateDetail.id}`}
            value={resolvedProvider}
            placeholder="No provider."
            onChange={(event) => {
              onProviderChange(event.target.value);
            }}
            onBlur={async (event) => {
              await onProviderSave(event.target.value);
            }}
          />
        </div>
      );
    })}
  </div>
);

export default CodeReferenceList;
